import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconTag.tsx
const IconTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "#998e8e",
		d: "m10.904 2.1 9.9 1.414 1.414 9.9-9.192 9.192a1 1 0 0 1-1.415 0l-9.9-9.9a1 1 0 0 1 0-1.414zm.707 2.12L3.833 12l8.485 8.484 7.779-7.778-1.061-7.424zm2.122 6.365a2 2 0 1 1 2.828-2.829 2 2 0 0 1-2.828 2.829"
	})]
});
var IconTag_default = forwardRef(IconTag);
//#endregion
export { IconTag_default as default };
